import {
    ComponentFactoryResolver, ComponentRef,
    Directive,
    ElementRef,
    HostListener,
    OnInit,
    Renderer2,
    ViewContainerRef
} from '@angular/core';
import {NgControl} from '@angular/forms';
import {ClearButtonComponent} from './components/clear-button/clear-button.component';

@Directive({
    selector: '[inputTextClear]'
})
export class InputTextClearDirective implements OnInit {
    componentRef: ComponentRef<ClearButtonComponent> = null;
    componentElement;
    constructor(private renderer: Renderer2, private element: ElementRef, private viewContainerRef: ViewContainerRef,
                private componentFactoryResolver: ComponentFactoryResolver, private control: NgControl) {
    }

    ngOnInit() {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(ClearButtonComponent);
        this.componentRef = this.viewContainerRef.createComponent(componentFactory);
        this.componentRef.instance.element = this.control;
        this.componentRef.instance.isShow = false;
        this.componentElement = this.componentRef.location.nativeElement;
        this.element.nativeElement.insertAdjacentElement('afterend', this.componentElement);
    }

    @HostListener('keyup', ['$event'])
    onModelChange() {
        if (this.control.value) {
            this.componentRef.instance.isShow = true;
        } else {
            this.componentRef.instance.isShow = false;
        }
    }
}
